import React from 'react';
// -- lists and menus
import MenuItem from 'material-ui/MenuItem';
// -- form components
import Form from '../Common/Form.react';
import TextField from '../Common/TextField';
import SelectField from '../Common/SelectField';
import { FormsyCheckbox as Checkbox } from 'formsy-material-ui';
import { Card, CardText } from 'material-ui/Card';

import { statusColours } from '../../constants/ColourConstants';

import ScheduleIcon from 'material-ui/svg-icons/action/schedule';



import LinearProgress from 'material-ui/LinearProgress';
// business logic
import AssignmentActions from '../../actions/AssignmentActionCreator';
import AssignmentStore from '../../stores/AssignmentStore';
import FilterActions from '../../actions/FilterActionCreator';
import FilterStore from '../../stores/FilterStore';
import ProgrammeStore from '../../stores/ProgrammeStore';
import ProgrammeActions from '../../actions/ProgrammeActionCreator';
import ComplianceStore from '../../stores/ComplianceStore';
import { listCompliances } from '../../actions/ComplianceActionCreator';

// visual elements

const defined = (e) => e !== undefined;

const Assignment = React.createClass({

    getInitialState: function() {

        const isEdit = (this.props.routeParams.id !== undefined && !!this.props.routeParams.id.match(/\d+/));

        return {
            assignmentId: Number(this.props.routeParams.id) || null,
            isEdit: isEdit,
            redirectTo: (isEdit ? `/dashboard/assignment/${this.props.routeParams.id}` : '/dashboard/assignments'),
            details: {
                id: '',
                name: '',
                description: '',
                filterId: '',
                programmeId: '',
                complianceId: null,
                complianceName: '',
                status: 'enrolled',
                requirement: 2,
                type: 'delegate',
                schedule: '',
                auto: '',
                suppressEmails: false
            },
            filters: [],
            programmes: [],
            compliances: [],
            dropdowns: {
                typeOptions: ['delegate', 'trainer'],
            }
        }
    },

    componentDidMount: function() {
        this.listeners = [
            AssignmentStore.addListener(this._onChange),
            FilterStore.addListener(this._onFiltersChange),
            ComplianceStore.addListener(this.onComplianceChange),
        ];

        FilterActions.getAll();

        ProgrammeStore.addChangeListener(this._onProgrammesChange);
        ProgrammeActions.getAll();

        if (this.state.isEdit) {
            AssignmentActions.getById(this.state.assignmentId);
            this._onChange();
        }

        listCompliances();
        this.onComplianceChange();
    },

    componentWillUnmount: function() {
        this.listeners.forEach(listener => listener.remove());
        ProgrammeStore.removeChangeListener(this._onProgrammesChange);
    },

    render: function() {

        let formProps = {
            title: this.state.isEdit ? this.state.details.name : 'New assignment',
            onSave: this._onSubmit,
            redirectTo: false
        };
        
        let progressBar = '';
        if ((this.state.isEdit && this.state.details.id === '') || this.state.filters.length === 0 || this.state.programmes.length === 0) {
            progressBar = <LinearProgress mode="indeterminate" />;
        }

        let schedule;
        if (!!this.state.details.auto) {
            let scheduleProps = {
                name:              "schedule",
                value:             this.state.details.schedule,
                hintText:          "hh:mm",
                floatingLabelText: "Time (hh:mm)",
                required:          true,
            };
            schedule = <TextField {...scheduleProps} />
        }
        return (

            <Form {...formProps} >
                <Card className="cent-card">
                    <CardText>
                        <TextField
                            name="name"
                            value={this.state.details.name}
                            validations={{ matchRegexp: /[a-z0-9 ]+/i }}
                            validationErrors={{matchRegexp: 'Use only letters, numbers or spaces'}}
                            hintText="Name"
                            floatingLabelText="Name"
                            required
                        />
                        <TextField
                            name="description"
                            value={this.state.details.description}
                            validations={{ matchRegexp: /[a-z0-9 ]+/i }}
                            validationErrors={{matchRegexp: 'Use only letters, numbers or spaces'}}
                            hintText="Description"
                            floatingLabelText="Description"
                        />
                        <div className='cent-flex-row'>
                            <div className='cent-col-2'>
                                <SelectField
                                    name="filter"
                                    value={this.state.details.filterId}
                                    hintText="Filter"
                                    floatingLabelText="Filter"
                                    autoWidth={true}
                                    required
                                >
                                    {this.state.filters}
                                </SelectField>
                            </div>
                            <div className='cent-col-2'>
                                <SelectField
                                    name="type"
                                    value={this.state.details.type}
                                    floatingLabelText="Type"
                                    hintText="Type"
                                    autoWidth={true}
                                    required
                                >
                                    {this.state.dropdowns.typeOptions
                                        .map((type) => (<MenuItem key={type} value={type} primaryText={type} />))}
                                </SelectField>
                            </div>
                            <div className='cent-col-2'>
                                <SelectField
                                    name="programme"
                                    value={this.state.details.programmeId}
                                    hintText="Programme"
                                    floatingLabelText="Programme"
                                    autoWidth={true}
                                >
                                    <MenuItem value={0} primaryText="No programme" />
                                    {this.state.programmes}
                                </SelectField>
                            </div>
                            <div className='cent-col-2'>
                                <SelectField
                                    name="compliance"
                                    value={this.state.details.complianceId}
                                    hintText="Compliance"
                                    floatingLabelText="Compliance"
                                    autoWidth={true}
                                >
                                    <MenuItem value={0} primaryText="No compliance" />
                                    {this.state.compliances.map(({id, name})  => (<MenuItem key={id} value={id} primaryText={name} />))}
                                </SelectField>
                            </div>

                            <div className='cent-col-1'>
                                <div className='cent-checkbox-wrapper'>
                                    <div className='cent-checkbox-hint'>Make assigned courses mandatory</div>
                                    <Checkbox
                                        name="requirement"
                                        value={this.state.details.requirement === 1}
                                        label="Mandatory"
                                        onChange={this._onEdit}
                                    />
                                </div>
                            </div>
                            <div className='cent-col-1'>
                                <div className='cent-checkbox-wrapper'>
                                    <div className='cent-checkbox-hint'>Add users to the waiting list of the assigned courses</div>
                                    <Checkbox
                                        name="status"
                                        value={this.state.details.status === 'waiting'}
                                        label="Add to waiting list"
                                        onChange={this._onEdit}
                                    />
                                </div>
                            </div>
                            <div className='cent-col-1'>
                                <div className='cent-checkbox-wrapper'>
                                    <div className='cent-checkbox-hint'>Users can retake courses after completing them</div>
                                    <Checkbox
                                        name="canRetake"
                                        value={!!this.state.details.canRetake}
                                        label="Can retake"
                                        onChange={this._onEdit}
                                    />
                                </div>
                            </div>
                            <div className='cent-col-1'>
                                <div className='cent-checkbox-wrapper'>
                                    <div className='cent-checkbox-hint'>Suppress enrolment email notifications</div>
                                    <Checkbox
                                        name="suppressEmails"
                                        value={!!this.state.details.suppressEmails}
                                        label="Suppress emails"
                                        onChange={this._onEdit}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='cent-checkbox-wrapper'>
                            <div className='cent-checkbox-hint'>Run assignment daily at a specific time</div>
                            <Checkbox
                                name="auto"
                                checkedIcon={<ScheduleIcon color={statusColours.primary} />}
                                uncheckedIcon={<ScheduleIcon color={statusColours.light} />}
                                value={!!this.state.details.auto}
                                label="Enable scheduler"
                                onChange={this._onEdit}
                            />
                        </div>
                    {schedule}
                    </CardText>
                    {progressBar}
                </Card>
            </Form>
        )
    },

    _onSubmit: function (model) {
        model.requirement = !!model.requirement ? 1 : 2;
        model.status = !!model.status ? 'waiting' : 'enrolled';
        if(this.state.isEdit) {
            return AssignmentActions.update(this.state.assignmentId, model);
        } else {
            return AssignmentActions.save(model);
        }
    },

    _onChange: function() {
        let details = AssignmentStore.getById(this.state.assignmentId);
        if (details !== undefined) {
            this.setState({details});
        }
    },

    _onFiltersChange: function() {
        let filters = FilterStore.getAll();
        if (filters !== undefined) {
            let filterlist = filters.filter(defined).map(function(filter) {
                return <MenuItem key={filter.id} value={filter.id} primaryText={filter.name} />
            });
            this.setState({filters: filterlist});
        }
    },
    
    _onProgrammesChange: function() {
        let programmes = ProgrammeStore.getAll();
        if (programmes !== undefined) {
            const programmeList = programmes.filter(defined).map(({id, name}) =><MenuItem key={id} value={id} primaryText={name} />);
            this.setState({programmes: programmeList});
        }
    },

    onComplianceChange: function() {
        const compliances = ComplianceStore.getList();
        if (compliances) {
            this.setState({compliances});
        }
    },
    _onEdit: function(event, value) {
        if (this.state.details[event.target.name] !== undefined) {
            this.setState({ details: {...this.state.details, [event.target.name]: value}});
        }
    }
});

export default Assignment;
